export const SupportedCurrencies = [
	'USD',
	'CAD',
	'GBP',
	'EUR',
	'AUD',
	'CHF'
];
